import * as Types from '../../@types/graphql-types';

import gql from 'graphql-tag';
export type SetUcConsentsMutationVariables = Types.Exact<{
	input: Types.SetUcConsentsInput;
}>;

export type SetUcConsentsMutation = {
	__typename?: 'Mutation';
	setUCConsents: {
		__typename?: 'SetUCConsentsPayload';
		ucConsents: Array<{ __typename?: 'UCConsentItem'; id: string; name: string; granted: boolean }>;
	};
};

export const SetUcConsentsDocument = gql`
	mutation SetUCConsents($input: SetUCConsentsInput!) {
		setUCConsents(input: $input) {
			ucConsents {
				id
				name
				granted
			}
		}
	}
`;
